import React from 'react';
import TextHome from '../component/home/textHome';

const Home = () => {
    return (
        <div className='home  d-flex align-items-center justify-content-between'>
                <TextHome/>
           
        </div>
    );
}

export default Home;
